<template>
  <ToggleSection
    v-if="isVisible"
    label="Sharing"
    icon-classes="fa-solid fa-share-nodes"
    :collapsed="collapsed || !dv.isEditing"
  >
    <FieldGrid :fields="[['permissions']]" :dv="dv" />
  </ToggleSection>
</template>

<script>
import { computed } from 'vue'
import ToggleSection from '@/components/fields/ToggleSection.vue'
import FieldGrid from '@/components/fields/FieldGrid.vue'

export default {
  name: 'EntitySharing',
  components: {
    ToggleSection,
    FieldGrid,
  },
  props: {
    dv: { type: Object, required: true },
    collapsed: { type: Boolean, default: true },
  },
  setup(props) {
    const isVisible = computed(() =>
      props.dv.visibleFields?.some((f) => f.name === 'permissions'),
    )
    return { isVisible }
  },
}
</script>
